export const myValuesSteps = [
  {
    target: '#start-item',
    content: 'Esta página é destinada a configuração de valores.',
    disableBeacon: true,
  },
  {
    target: '#select-state',
    content: 'Selecione um estado e os seus serviços serão exibidos abaixo. ',
  },
  {
    target: '#my-values',
    content:
      'Todos os serviços que você selecionou no perfil serão mostrados aqui separadamente. Você pode alterar o valor de cada um deles.',
    delay: 1000,
  },
  {
    target: '#apply-values',
    content:
      'Aqui é possivel aplicar os mesmos valores configurados a mais estados simultaneamente.',
  },
  {
    target: '#apply-values-button',
    content: 'Aplique as mudanças',
  },
  {
    target: '#save',
    content: 'Salve todas as configurações',
  },
];
